import memoize from 'lodash/memoize';

const isMobile = memoize((width) => width <= 880);

export default isMobile;
